import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SignalRService } from 'projects/shared/src/services/signal-rservice.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-basic-layout',
  templateUrl: './basic-layout.component.html',
  standalone: false
})
export class BasicLayoutComponent {
  basicFooter = false;

  constructor(
    public router: Router,
    private signal: SignalRService,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((routeChange: any) => {
      this.basicFooter = this.router.url.includes('/user-profile')
    });
    this.signal.startConnection();
  }
}
